module.exports = __webpack_public_path__ + "img/teeth-18.78151031.png";